<template>
  <section class="promotion-section">
    <h2 class="section-title">
      推广生态赚取
      <span class="highlight">额外收益</span>
    </h2>

    <div class="promo-card">
      <div
        v-for="(item, index) in promoItems"
        :key="index"
        class="promo-block"
      >
        <img
          :src="item.icon"
          :alt="item.title"
          class="promo-icon"
          :style="item.iconStyle"
          @load="handleIconLoad($event, item)"
        />
        <h3 class="promo-title">{{ item.title }}</h3>
        <p class="promo-desc">{{ item.desc }}</p>
      </div>
    </div>

    <AnimatedSvgIllustration
      :src="svg3Url"
      uid="promo-svg3"
      class="bottom-illustration"
    />
  </section>
</template>

<script>
import { PROMOTION_ITEMS } from "../config";
import AnimatedSvgIllustration from "./AnimatedSvgIllustration.vue";
import svg3Url from "@/assets/image/svg3.svg";

export default {
  components: {
    AnimatedSvgIllustration,
  },
  data() {
    return {
      promoItems: PROMOTION_ITEMS.map((item) => ({
        ...item,
        iconStyle: null,
      })),
      svg3Url,
    };
  },
  methods: {
    handleIconLoad(event, item) {
      const img = event.target;
      if (!img.naturalWidth || !img.naturalHeight) return;

      this.$set(item, "iconStyle", {
        width: `${img.naturalWidth * 0.6}px`,
        height: `${img.naturalHeight * 0.6}px`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.promotion-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 0 0 30px;
  font-size: 50px;
  font-weight: normal;
  line-height: 1.3;
  color: #fff;
  text-align: center;

  .highlight {
    color: #7338ff;
  }
}

.promo-card {
  margin-bottom: 40px;
  border-radius: 24px;
  background: #040a28;
  border: 1px solid rgba(192,192,192,0.4);
  overflow: hidden;
}

.promo-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 34px 24px;
  text-align: center;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(192,192,192,0.4);
  }
}

.promo-icon {
  display: block;
  margin-bottom: 20px;
  object-fit: contain;
}

.promo-title {
  margin: 0 0 14px;
  font-size: 32px;
  font-weight: normal;
  color: #fff;
}

.promo-desc {
  margin: 0;
  font-size: 26px;
  line-height: 1.5;
  color: #c0c0c0;
}

.bottom-illustration {
  display: block;
  width: 100%;
  margin: 80px 0;
}
</style>
